import "./@services/wdyr";
import logger from "./@services/logger";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { LayoutProvider } from "./@context/LayoutContext";

if (!window._env_) {
  window._env_ = {};

  logger.error("No 'window._env_' was found!");
}

ReactDOM.render(
  <LayoutProvider>
    <App />
  </LayoutProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
